import api from '../services/api';
import { DEFAULT_IDP } from './constants';

/**
 * Checks if users email domain has IdP setup. In any other case defaults to myosh-default.
 * @param email
 * @returns domain boolean
 */

export const checkIdp = async (email: string) => {
  // Domain names are case-insensitive, but Cognito matches the IdP identifier
  // as an exact-match (case-sensitive) string. Canonicalise to lowercase so the
  // domain is recognised on both the hasCognitoIdentityProvider check and the
  // idp_identifier reused for the Cognito redirect.
  const domain = email.substring(email.lastIndexOf('@') + 1).toLowerCase();
  return api<boolean>(`hasCognitoIdentityProvider?domain=${domain}`)
    .then((response) => {
      if (response === true) {
        return domain;
      } else {
        return DEFAULT_IDP;
      }
    })
    .catch(() => DEFAULT_IDP);
};
